import { baseReducer as BaseReducer } from '../../store/core/base-reducer';

import * as Actions from './print.actions';
import { UPDATE_PRINTERS_SUCCESS, CLEAR_DEVICES_FOR_WORKSTATION } from '../shipstation-connect/ss-connect.actions';

const initialState = {
  outputType: 'print',
  optionalManuallySetDocCount: 0,
};

// TODO: Make this less getter setter
const actionHandlerMap = {
  [Actions.PRINT_MODAL_OPEN]: (state, action) => {
    const { pdfFilePath, documentType, fulfillmentPlanIds, fulfillmentIds, fulfillmentPlanSetIds, endOfDayScanFormIds } = action;
    return {
      ...state,
      pdfFilePath,
      documentType,
      fulfillmentPlanIds,
      fulfillmentIds,
      fulfillmentPlanSetIds,
      endOfDayScanFormIds,
      isLoading: false,
    };
  },
  [Actions.SET_PRINT_DESTINATION]: (state, action) => {
    const { printDestination } = action;
    return {
      ...state,
      printDestination,
    };
  },
  [Actions.SET_PRINT_FORMAT]: (state, action) => {
    const { printDocumentFormat } = action;
    return {
      ...state,
      printDocumentFormat,
    };
  },
  [Actions.SET_REMEMBER_PRINT_SETTINGS]: (state, action) => {
    const { rememberPrintSettings } = action;
    return {
      ...state,
      rememberPrintSettings,
    };
  },
  [Actions.CHANGE_OUTPUT_TYPE]: (state, action) => {
    const { outputType } = action;
    return {
      ...state,
      outputType,
    };
  },
  [Actions.PRINT_MODAL_CLOSING]: (state) => {
    return {
      ...initialState,
      printDestination: state.printDestination,
      // preserve this so epics can access it
      rememberPrintSettings: state.rememberPrintSettings,
    };
  },
  [Actions.PRINT_MODAL_OPEN]: (state) => {
    return {
      ...state,
      rememberPrintSettings: false,
    };
  },
  [Actions.MANUALLY_SET_DOC_COUNT]: (state, { docCount }) => {
    return {
      ...state,
      optionalManuallySetDocCount: docCount,
    };
  },
  [Actions.PRINT_MODAL_OPEN_END_OF_DAY_FORM]: (state, action) => {
    const { pdfFilePath, endOfDayScanFormIds } = action;

    return {
      ...state,
      pdfFilePath,
      endOfDayScanFormIds,
    };
  },
  [UPDATE_PRINTERS_SUCCESS]: (state, { printers }) => {
    if (state.printDestination || !printers || printers.length === 0) {
      return state;
    }
    return {
      printDestination: printers[0],
    };
  },
  [CLEAR_DEVICES_FOR_WORKSTATION]: (state, { workstationId }) => {
    const { printDestination } = state;
    if (!printDestination || printDestination.workstationId !== workstationId) {
      return state;
    }
    return {
      ...state,
      printDestination: undefined,
    };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './print.reducer.metadata';
